import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router';
import Home from '@/views/Home.vue';
import { isLoggedIn } from '@/api/auth';
import { ElMessage } from 'element-plus';

const routes: Array<RouteRecordRaw> = [
    {
        path: '/redirect/:path*',
        component: () => import('@/views/Redirect.vue'),
    },
    {
        path: '/',
        redirect: '/productManagement',
    },
    // 登录页面（无需认证）
    {
        path: '/login',
        name: 'Login',
        component: () => import('@/views/Login.vue'),
        meta: { requiresAuth: false },
    },
    {
        path: '/index',
        name: 'Home',
        component: Home,
        meta: { requiresAuth: true },
    },
    {
        path: '/:catchAll(.*)',
        name: '404',
        component: () => import('@/views/404.vue'),
    },
    {
        path: '/productManagement',
        name: '产品管理',
        component: () => import('@/views/productManagement/index.vue'),
        meta: { requiresAuth: true },
    },
    {
        path: '/productManagement/add',
        name: '产品编辑',
        component: () => import('@/views/productManagement/add.vue'),
        meta: { requiresAuth: true },
    },
    {
        path: '/productManagement/sku',
        name: 'SKU管理',
        component: () => import('@/views/productManagement/skuManagement.vue'),
        meta: { requiresAuth: true },
    },
    {
        path: '/productManagement/stockPrice',
        name: '库存价格管理',
        component: () =>
            import('@/views/productManagement/stockPriceManagement.vue'),
        meta: { requiresAuth: true },
    },
    // 订单管理模块
    {
        path: '/orderManagement',
        name: '订单管理',
        component: () => import('@/views/orderManagement/index.vue'),
        meta: { requiresAuth: true },
    },
    // 出行管理模块
    {
        path: '/travelManagement',
        name: '出行管理',
        component: () => import('@/views/travelManagement/index.vue'),
        meta: { requiresAuth: true },
    },
    // 轮播图管理模块
    {
        path: '/bannerManagement',
        name: '轮播图管理',
        component: () => import('@/views/bannerManagement/index.vue'),
        meta: { requiresAuth: true },
    },
    // 账号管理模块
    {
        path: '/accountManagement',
        name: '账号管理',
        component: () => import('@/views/accountManagement/index.vue'),
        meta: { requiresAuth: true },
    },
    // 角色管理模块
    {
        path: '/roleManagement',
        name: '角色管理',
        component: () => import('@/views/roleManagement/index.vue'),
        meta: { requiresAuth: true },
    },
    // 数据统计模块
    {
        path: '/dataStatistics',
        name: '数据统计',
        component: () => import('@/views/dataStatistics/index.vue'),
        meta: { requiresAuth: true },
    },
    // 短信模板管理模块
    {
        path: '/smsTemplate',
        name: '短信模板管理',
        component: () => import('@/views/smsTemplate/index.vue'),
        meta: { requiresAuth: true },
    },
    // 系统设置模块
    {
        path: '/settings',
        name: '系统设置',
        component: () => import('@/views/settings/index.vue'),
        meta: { requiresAuth: true },
    },
];

const router = createRouter({
    history: createWebHashHistory(),
    routes,
});

// 路由守卫：检查登录状态
router.beforeEach((to, from, next) => {
    // 如果路由需要认证
    if (to.meta.requiresAuth !== false) {
        if (!isLoggedIn()) {
            // 未登录，跳转到登录页
            ElMessage.warning('请先登录');
            next({
                path: '/login',
                query: { redirect: to.fullPath }, // 保存原始路径，登录后跳转回来
            });
            return;
        }
    }

    // 如果已登录且访问登录页，跳转到首页
    if (to.path === '/login' && isLoggedIn()) {
        next('/productManagement');
        return;
    }

    next();
});

export default router;
